import script from "./CurrentLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentLanguage.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentLanguage.vue?vue&type=style&index=0&id=2ab4c3b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab4c3b2"]])

export default __exports__